import { render, staticRenderFns } from "./SalesPageNew.vue?vue&type=template&id=7f45e072&scoped=true&"
import script from "./SalesPageNew.vue?vue&type=script&lang=js&"
export * from "./SalesPageNew.vue?vue&type=script&lang=js&"
import style0 from "./SalesPageNew.vue?vue&type=style&index=0&id=7f45e072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f45e072",
  null
  
)

export default component.exports